export default {
  close: 'Close',
} as const;
